import {
  GET_ATTENDANCE_LIST_BY_ADMIN_REQUEST,
  GET_ATTENDANCE_LIST_BY_ADMIN_SUCCESS,
  GET_ATTENDANCE_LIST_BY_ADMIN_FAILURE,
} from "./actionType";

import { getAttendanceList, getAttendanceListReport } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";
import {
  STATUS_VALUE_ZERO,
  STATUS_ZERO,
} from "../../components/attendance/Constants";
import { type } from "../../components/helper/Constant";

const getAttendanceByAdmin = (props) => {
  let { useDispatch, tabStatus, params, dataCount, isReportPage, AttendanceDetails } = props;
  return (dispatch) => {
    dispatch(getAttendanceByAdminRequest());
    const fetcher = isReportPage ? getAttendanceListReport : getAttendanceList;
    fetcher(params)
      .then((res) => {
        useDispatch({
          type: type,
          payload: { miniLoader: false },
        });

        const { status, resData } = ResponseFilter(res);

        if (status) {
          if (isReportPage) {
            const mergedAttendanceData = [
              ...AttendanceDetails,
              ...resData.AttendenceDetails,
            ];

            const seen = new Set();
            const filteredData = mergedAttendanceData.filter((item) => {
              if (seen.has(item._id)) return false;
              seen.add(item._id);
              return true;
            });

            const statusData = mapStatusByType(resData.statusByType);
            const totalCount =
              tabStatus === STATUS_ZERO || tabStatus === ""
                ? resData.totalAttendence
                : dataCount;
            const hasMore = filteredData.length < totalCount;

            useDispatch({
              type: type,
              payload: {
                avgOfficeHours: resData.avgOfficeHours,
                AttendanceDetails: filteredData,
                pageNo: hasMore ? params.pageNo + 1 : 0,
                dataCount: totalCount,
                totalAttendance: resData.totalAttendence,
                ...statusData,
                loading: isReportPage ? hasMore : null
              },
            });
          } else {
            // ✅ Normal flow (non-report)
            const statusData = mapStatusByType(resData.statusByType);

            useDispatch({
              type: type,
              payload: {
                avgOfficeHours: resData.avgOfficeHours,
                AttendanceDetails: resData.AttendenceDetails,
                pageNo: params.pageNo + 1,
                dataCount:
                  tabStatus === STATUS_ZERO || tabStatus === ""
                    ? resData.totalAttendence
                    : dataCount,
                totalAttendance: resData.totalAttendence,
                ...statusData,
              },
            });
          }
        } else {
          useDispatch({
            type: type,
            payload: {
              responseMessage:
                res.data.error.errors[0].message ||
                res.data.error.responseMessage,
              errorCode: res.data.error.errorCode,
              resMsgFail: true,
            },
          });
          setTimeout(
            () =>
              useDispatch({
                type: type,
                payload: { resMsgFail: false },
              }),
            3000
          );
        }
      })
      .catch((error) => {
        dispatch(getAttendanceByAdminFailure(error));
      });
  };
};

const mapStatusByType = (statusByType) => {
  const isValid = statusByType !== STATUS_VALUE_ZERO;
  const getStatus = (id) => isValid ? statusByType.filter((data) => data._id === id) : 0;

  return {
    statusByType: isValid ? statusByType : [],
    present: getStatus(1),
    late: getStatus(2),
    absent: getStatus(3),
    missedCheckOut: getStatus(4),
    missedCheckIn: getStatus(11),
    lateAndTotalHoursNotComplete: getStatus(10),
    earlyCheckOutTab: getStatus(6),
    onLeave: getStatus(5),
    workFromHome: getStatus(7),
    Others: getStatus(8),
    halfOthers: getStatus(9),
    halfWfh: getStatus(12),
    bereavementLeaves: getStatus(21),
    parentingLeave: getStatus(20),
    clientOff: getStatus(19),
  };
};

const getAttendanceByAdminRequest = () => {
  return {
    type: GET_ATTENDANCE_LIST_BY_ADMIN_REQUEST,
  };
};

const getAttendanceByAdminSuccess = (data) => {
  return {
    type: GET_ATTENDANCE_LIST_BY_ADMIN_SUCCESS,
    payload: data,
  };
};

const getAttendanceByAdminFailure = (error) => {
  return {
    type: GET_ATTENDANCE_LIST_BY_ADMIN_FAILURE,
    payload: error,
  };
};
export {
  getAttendanceByAdmin,
  getAttendanceByAdminRequest,
  getAttendanceByAdminSuccess,
  getAttendanceByAdminFailure,
};
